import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppShell, Box, Button, Chip, IconButton, SideNav, SideNavHeader, SideNavItem, SideNavList, Stack, TextField, Tooltip, } from "@merchant-trends/ds-ui";
import { Bell, Building2, ChevronDown, CreditCard, Home, Plug, Search, Settings, } from "lucide-react";
import { useState } from "react";
import { space } from "../tokens.js";
import { railItems, } from "./rail.js";
const ICONS = {
    checkout: CreditCard,
    connect: Plug,
    customers: Building2,
    home: Home,
    settings: Settings,
};
const UNAVAILABLE_TITLE = {
    "coming-soon": "Coming soon",
    "not-linked": "Not linked in this deployment",
};
/**
 * The Nexus frame both apps render inside (NEX2-232): the design system's `AppShell` with the Nexus
 * rail and the top bar, matching the design team's `NexusShell`. It was Checkout's `CheckoutFrame`
 * (NEX2-70) and moved here so the portal draws the same one.
 *
 * What each rail item does comes from `railItems`. A destination in the other app opens its origin
 * as a page load, because the two apps are separate deployments. Search, the site switcher and
 * notifications stay disabled until they have something to ask; the site switcher is the next
 * NEX2-232 pull request. No brand is activated here yet (`FE-04`).
 */
export function NexusFrame({ active, apiOrigin, app, children, environment, links, onNavigate, }) {
    const [collapsed, setCollapsed] = useState(true);
    const rail = railItems({ active, app, links });
    const renderItem = (item, close) => {
        const { state } = item;
        const open = () => {
            if (state.kind === "active" || state.kind === "route") {
                onNavigate(state.path);
            }
            else if (state.kind === "url") {
                window.location.assign(state.href);
            }
            close();
        };
        return (_jsx(SideNavItem, { active: state.kind === "active", disabled: state.kind === "unavailable", icon: ICONS[item.key], label: item.label, onClick: open, ...(state.kind === "unavailable" ? { title: UNAVAILABLE_TITLE[state.reason] } : {}) }, item.key));
    };
    return (_jsx(AppShell, { actions: _jsxs(Stack, { alignItems: "center", direction: "row", spacing: 2, children: [_jsx(Tooltip, { title: `API ${apiOrigin}`, children: _jsx("span", { children: _jsx(Chip, { size: "small", tone: "neutral", children: environment }) }) }), _jsx(Button, { disabled: true, icon: _jsx(ChevronDown, { size: 16 }), iconPosition: "right", size: "medium", variant: "outlined", children: "All sites" }), _jsx(IconButton, { "aria-label": "Notifications", disabled: true, icon: _jsx(Bell, { size: 18 }), variant: "ghost" })] }), leading: _jsx(Box, { sx: { maxWidth: "16rem", width: "100%" }, children: _jsx(TextField, { "aria-label": "Search Nexus", disabled: true, fullWidth: true, leadingIcon: _jsx(Search, { size: 16 }), placeholder: "Search" }) }), maxWidth: "xl", sidebar: ({ mobile, close }) => (_jsxs(SideNav, { collapsed: !mobile && collapsed, forceExpanded: mobile, children: [_jsx(SideNavHeader, { ...(mobile
                        ? {}
                        : {
                            onToggleCollapsed: () => {
                                setCollapsed((value) => !value);
                            },
                        }) }), _jsx(SideNavList, { grow: true, children: rail.main.map((item) => renderItem(item, close)) }), _jsx(SideNavList, { children: rail.footer.map((item) => renderItem(item, close)) })] })), children: _jsx(Box, { sx: { padding: space("lg") }, children: _jsx(Stack, { direction: "column", spacing: 6, children: children }) }) }));
}
//# sourceMappingURL=NexusFrame.js.map